import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import * as color from '../../../constants/colors';
import * as authConstants from '../../../constants/auth';
import * as storage from '../../../persistance/storage';

import {saveLogin} from '../../../utils/auth';
import {emailValidation, passwordValidation} from '../../../utils/itemValidation';

import {LoginButton} from './LoginButton';

import * as authActionCreators from '../../../actions/auth';
import * as loginActionCreators from '../../../actions/login';
let allActionCreators = Object.assign({}, loginActionCreators, authActionCreators);


class Login extends React.Component {


  constructor(props) {
    super(props);

    let savedEmail = storage.get('rememberEmail');

    this.state = {
      requestPending: false,
      serverError: null,
      email: savedEmail === null ? '' : savedEmail,
      password: '',
      shouldRemember: savedEmail !== null,
      errors: {
        email: null,
        password: null,
      },

      localLoginOpen: false,
    };
  }

  componentDidMount() {
    this.props.checkLocalAuth()
    .then((respData) => {
      this.setState({ localLoginOpen: true });
    })
    .catch((errorData) => {
      this.setState({ localLoginOpen: false });
    });
  }

  changeEmail(evt) {
    this.setState({ email: evt.target.value });
  }

  validateEmail() {
    setTimeout(() => {
      this.setState({ errors: Object.assign({}, this.state.errors, {email: emailValidation(this.state.email)}) });
    }, 100);
  }

  changePassword(evt) {
    this.setState({
      password: evt.target.value
    })
  }

  validatePassword() {
    this.setState({ errors: Object.assign({}, this.state.errors, {password: passwordValidation(this.state.password)}) });
  }

  registerNav() {
    history.push('/register');
  }

  forgotPasswordNav() {
    history.push('/forgot-password');
  }

  validateAll() {
    let emailError = emailValidation(this.state.email);
    let passwordError = passwordValidation(this.state.password);

    this.setState({
      errors: Object.assign({}, this.state.errors, {
        email: emailError,
        password: passwordError,
      })
    });
    if(
      emailError === null &&
      passwordError === null
    ) {
      return true;
    } else {
      return false;
    }
  }

  handleSubmit(evt) {

    if(evt) { evt.preventDefault(); }

    if(this.validateAll()) {

      this.setState({
        requestPending: true,
        serverError: null,
      });
      this.props.callLogin(this.state.email, this.state.password)
      .then((respData) => {
        
        this.setState({
          requestPending: false,
          serverError: null,
        });


        saveLogin(respData.auth.auth_token, respData.auth.admin, respData.auth.role, respData.auth.remote, respData.auth.user.id, respData.auth.user);
        this.props.authSave(respData.auth.auth_token, respData.auth.admin, respData.auth.role, Date.now() + authConstants.LOGOUT_TIME, respData.auth.user.id);

        document.getElementsByTagName("META")[2].content="width=device-width, height=device-height, viewport-fit=cover, initial-scale=1.0";

        if(this.state.shouldRemember) {
          storage.put('rememberEmail', this.state.email);  
        } else {
          storage.remove('rememberEmail');
        }     

        setTimeout(() => {
          if(respData.auth.need_password_reset) {
            history.push('/update-password');
          } else {

            if(Object.keys(this.props.diamonds.diamondFilter).length > 0 || this.props.diamonds.selectedList.length > 0) {
              history.push('/results');              
            } else {
              history.push('/diamonds');
            }
          }
        }, 100);
      })
      .catch((errorData) => {
        
        let connectError = 'Cannot connect to Diamonds Direct.';
        let passwordError = 'Incorrect email/password combination.';
        let genericError = 'An error occured. Please try again.'

        let errorMessage = errorData.message ? errorData.message : connectError;

        if(errorMessage != connectError && errorMessage != passwordError) {
          errorMessage = genericError;
        }

        this.setState({
          requestPending: false,
          serverError: errorMessage,
        });
      });
    } 
  }

  shouldRemember(evt) {
    this.setState({shouldRemember: !this.state.shouldRemember});
  }


  render() {

    return <div className='Login'>
      <div className='formBodyWrapper'>
        <div className='formLogoWrapper' style={{ display: 'none' }}>
          <img src='/img/login/logotag.svg' />
        </div>
        <div className='loginTitle'>Employee Login</div>
        <div className='loginBr'>
          <img src='/img/manageusers/iconline_thinlight2.svg' />
        </div>
        {this.state.serverError ? 
          <div className='externalError'>{this.state.serverError}</div> :
          null
        }
        <form 
          className='ResponsiveForm'
          onSubmit={this.handleSubmit.bind(this)}>
          
          <div className='rememberWrapper' onClick={this.shouldRemember.bind(this)} style={{ display: 'none' }}>
            <input type='checkbox' checked={this.state.shouldRemember} /> Remember Me
          </div>
          <div 
            className='forgotLink'
            style={{ display: 'none' }}
            onClick={this.forgotPasswordNav.bind(this)}>
            Forgot password?
          </div>
          <div className='formRow' style={{ marginTop: '50px', textAlign: 'center', fontSize: '24px', fontWeight: '300'}}>
            <div className='formCopy'>
              Click below to login with your Diamonds Direct credentials.
            </div>
          </div>
          <div className='formRow'>
            <LoginButton />
          </div>
        </form>
        <div className={this.state.localLoginOpen ? 'localLogin open' : 'localLogin'}>
          <div className='llLiner'>
            <div className='loginOr'>
              or
            </div>
            <div className='loginTitle'>Use DD App Login</div>
            <div className='loginBr'>
              <img src='/img/manageusers/iconline_thinlight2.svg' />
            </div>
            <form 
              className={'ResponsiveForm secondaryLogin'}
              onSubmit={this.handleSubmit.bind(this)}>
              <div className={'copy copyEm'}>You are connected to a Diamonds Direct network</div>
              <div className='copy'>When not connected to a DD network, you will have to login with Microsoft.</div>
              <div className='formRow'>
                <div className='inputWrapper'>
                  <input
                    value={this.state.email} 
                    onChange={this.changeEmail.bind(this)} 
                    onBlur={this.validateEmail.bind(this)}
                    placeholder='Email Address'
                    type='email' />
                </div>
              </div>
              <div className='formRow'>
                <div className='inputWrapper'>
                  <input
                    value={this.state.password} 
                    onChange={this.changePassword.bind(this)} 
                    onBlur={this.validatePassword.bind(this)}
                    placeholder='Password'
                    type='password' />
                </div>
              </div>
              <div className={'loginSubmit actionButton'} onClick={this.handleSubmit.bind(this)} style={{ marginTop: '25px' }}>Login</div>
            </form>
          </div>
        </div>
      </div>
    </div>;
  }
}
export default Login;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    diamonds: state.diamonds,
  };
}

export const LoginContainer = connect(
  mapStateToProps,
  allActionCreators
)(Login);